<template>
	<keep-alive>
		<div class="tw-w-full">
			<div class="elearning">
				<div class="tw-flex">
					<!-- lesson -->
					<router-view :key="route" :course="courseCatalog" :full_screen="full_screen" @toggleFullScreen="toggleFullScreen"></router-view>

					<!-- sidebar -->
                    <sidebar v-if="courseCatalog" :course="courseCatalog" :course_fully_loaded="courseFullyLoaded" :full_screen="full_screen" @toggleFullScreen="toggleFullScreen"></sidebar>
                    <div class="sidebar-holder tw-bg-white tw-h-screen"
                         :class="[{'loaded': course_content_loaded}, {'full-screen': full_screen}]"></div>
				</div>
			</div>
		</div>
	</keep-alive>
</template>

<script>
import Sidebar from "../../components/e-learning/Sidebar";

export default {
	name: 'MainViewHolder',

	components: {
		'sidebar': Sidebar,
	},

	data() {
		return {
			full_screen: false,
			course_content_loaded: false,
		};
	},

	computed: {
		// remove tab param from route otherwise each tab will be cached separately which will result in multiple instances of the sidebar
		route() {
			let route = this.$route.path;

			if (typeof this.$route.params.tab !== 'undefined') {
				const tab_name = this.$route.params.tab;

				route = route.replace(`/${tab_name}`, '');
			}

			return route;
		},

		courseCatalog() {
			return CourseCatalogV4.query().where('slug', this.$route.params.course_slug).first();
		},

		courseFullyLoaded() {
			return (this.courseCatalog && this.courseCatalog.modules.length > 0) || this.course_content_loaded;
		},
	},

	methods: {
		toggleFullScreen() {
			setTimeout(() => {
				this.full_screen = !this.full_screen;
			}, 0);
		},
	},

	mounted() {
		//get all course (&modules) data
		if (!this.courseFullyLoaded) {
			CourseCatalogV4.api().fetchCourseCatalog(this.$route.params.course_slug).then(() => {
				this.course_content_loaded = true;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
	.sidebar-holder {
		transition: flex-basis 0.2s ease;
		flex-basis: 350px;
		box-shadow: -8px 0 10px -8px rgba(0, 0, 0, 0.1);

		@media(max-width: 1100px) {
			display: none;
		}

		&.full-screen {
			flex-basis: 0px;
		}

		&.loaded {
			box-shadow: none;
		}
	}
</style>
